import { render, staticRenderFns } from "./ShopManage.vue?vue&type=template&id=96f7d0c4&scoped=true&"
import script from "./ShopManage.vue?vue&type=script&lang=js&"
export * from "./ShopManage.vue?vue&type=script&lang=js&"
import style0 from "./ShopManage.vue?vue&type=style&index=0&id=96f7d0c4&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f7d0c4",
  null
  
)

export default component.exports